/* 

Copyright© Celligence International, LLC - 2023

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Logo } from "morgan-sign";

import XMark from "../Assets/Images/xmark.svg";
import { UserWayAccessibilityMenu } from "../Components/UserWayAccessibilityMenu";

const ErrorPage = () => {
  const theme = useTheme();
  const documentData = useLocation().state.data;

  useEffect(() => {
    let errorMessage = "Error Found";
    if (documentData) {
      errorMessage = documentData;
    };
    const iFrameErrorMessage = { error: errorMessage };
    window.parent.postMessage(iFrameErrorMessage, "*");
  }, [documentData])

  return (
    <div
      className="ErrorPage"
      style={{
        backgroundColor: "#083f88",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        minHeight: "100vh",
      }}
    >
      <img src={Logo} alt="logo" 
        style={{ 
          marginTop: "1rem", 
          maxWidth: "calc(100% - 2rem)", 
          height: "auto", 
          maxHeight:'200px',
          aspectRatio: "851/177" 
        }} 
      />
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "10px",
          maxWidth: "500px",
          height: "fit-content",
          display: "flex",
          margin: "1rem",
          padding: "1rem 2rem",
          flexDirection: "column",
          justifyContent: "space-around",
          alignItems: "center",
          gap: "1rem",
          color: "#083f88",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            alignSelf: "start",
          }}
        >
          There was an error processing your request.
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            alignSelf: "start",
          }}
        >
          An error occurred while loading the document. Please try again at a
          later time. If the problem persists, please include the issue down
          below and contact us at {theme.system.esignEmail + " "}
          and we will resolve the matter for you. We at{" "}
          {theme.system.companyName} strive to provide the best possible
          experience for our users.
        </Typography>
        <Typography variant="h6" sx={{ alignSelf: "start" }}>
          Error Details:
        </Typography>
        <Typography ariant="subtitle1" sx={{ alignSelf: "start" }}>
          "{documentData ? documentData : ""}"
        </Typography>
        <img src={XMark} alt="" height="80" style={{ marginTop: "1rem" }} />
      </div>
      <UserWayAccessibilityMenu color="white" transparent={true} height={30} top={"95%"} left={"95%"} />
    </div>
  );
};

export default ErrorPage;
